/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {UnitId} from "./units.js";

export type ContactId = string

export enum Gender {
    Empty = "UNKNOWN",
    Male = "MALE",
    Female = "FEMALE"
}

export type Response_DeleteContacts = {
    usersEmails: string[]
    deleted: string[]
    failed: string[]
}

export type Request_DeleteContacts = {
    unitId: UnitId
    contacts: string[]
}

export type Request_ListContacts = {
    unitId: UnitId
}

export type Request_UpdateContact = {
    unitId: UnitId
    contact: Contact
}

export type Request_UpdateGoogleContact = {
    userId: string
    contact: Contact
    unitId: UnitId
}

export type Response_UpdateGoogleContact = {
    beforeEmail?: string
    afterEmail?: string
    contact: Contact
}

export type Request_DeleteGoogleContact = {
    userId: string
    contactIds: string[]
    unitId: UnitId
}

export type Request_UpdateGoogleContactPhoto = {
    unitId: UnitId
    userId: string,
    contact: Contact
    profilePictureBase64?: string
}

export type Response_UpdateGoogleContactPhoto = {
    profilePictureUrl: string
}

export enum GroupType {
    CUSTOMER_SERVICE = "Care Team",
    CLINIC = "Clinic",
    EXTERNAL = "External"
}

export enum ContactType {
    Empty = "",
    Child = "CHILD",
    GrandChild = "GRANDCHILD",
    ElderSpouse = "ELDER_SPOUSE",
    InLaw = "IN_LAW",
    ProfessionalCareGiver = "PROFESSIONAL_CAREGIVER",
    Doctor = "DOCTOR",
    CareGiver = "CAREGIVER",
    Cousin = "COUSIN",
    NephewNiece = "NEPHEW_NIECE",
    Friend = "FRIEND",
    Sibling = "SIBLING",
    FamilyCareGiver = "FAMILY_CAREGIVER",
    FamilyMember = "FAMILY_MEMBER",
    CaseManager = "CASE_MANAGER",
    Elder = "ELDER",
    Other = "OTHER",
    Daughter = "DAUGHTER",
    Son = "SON",
    GrandDaughter = "GRANDDAUGHTER",
    GrandSon = "GRANDSON",
    Sister = "SISTER",
    Brother = "BROTHER",
    Neighbour = "NEIGHBOUR",
    Spouse = "SPOUSE",
    Wife = "WIFE",
    Husband = "HUSBAND",
}

export enum Role {
    Empty = "",
    Regular = "REGULAR",
    Administrator = "ADMINISTRATOR"
}

export type Address = {
    country: string;
    region: string;
    city: string;
    streetAddress: string;
    extendedAddress: string;
    postalCode: string;
}

export type Contact = {
    id?: string,
    firstName: string,
    lastName: string,
    SSML_Name?: string,
    emails: string[],
    gender: Gender
    role: Role,
    contactType: ContactType,
    birthday?: string,
    birthdayLong?: number,
    phoneNumbers?: string[],
    middleName?: string,
    facebookId?: string,
    profilePictureUrl?: string,
    recognitionId?: string | number,
    otherTypeDescription?: string,
    country?: string,
    region?: string,
    city?: string,
    streetAddress?: string,
    extendedAddress?: string,
    postalCode?: string
    etag?: string
};

export enum ContactActions {
    HARD_DELETE = "hard_delete",
    SOFT_DELETE = "soft_delete",
    CREATE = "create",
    UPDATE = "update"
}
